import { cognitoApi } from "./api";
import type { PublicationManifest } from "../utils/biPublication";

export type BootstrapGroupMembership = {
  id?: number;
  group_id: number;
  user_sub?: string;
  user_email?: string | null;
  user_name?: string | null;
  role: string;
  status: string;
};

export type BootstrapGlobalRole = {
  id?: number;
  user_sub?: string;
  user_email?: string | null;
  user_name?: string | null;
  role: string;
  status: string;
};

export type UserBootstrapPayload = {
  user_sub?: string | null;
  preferences?: Record<string, any>;
  publications?: PublicationManifest[];
  group_memberships?: BootstrapGroupMembership[];
  user_global_roles?: BootstrapGlobalRole[];
};

let bootstrapPromise: Promise<UserBootstrapPayload> | null = null;

export const userBootstrapApi = {
  get: async (): Promise<UserBootstrapPayload> => {
    if (!bootstrapPromise) {
      bootstrapPromise = cognitoApi
        .get<UserBootstrapPayload>("/cognito/bootstrap")
        .then((response) => response.data)
        .catch((error) => {
          bootstrapPromise = null;
          throw error;
        });
    }
    return bootstrapPromise;
  },

  clear: () => {
    bootstrapPromise = null;
  },
};
